import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const DAYS = ['mon','tue','wed','thu','fri','sat','sun'];
const DAY_LABELS = { mon:'Monday', tue:'Tuesday', wed:'Wednesday', thu:'Thursday', fri:'Friday', sat:'Saturday', sun:'Sunday' };

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [tab, setTab] = useState('store');

  useEffect(() => { api.get('/settings').then(r => setSettings(r.data)).catch(() => {}); }, []);

  const set = (k, v) => setSettings(s => ({ ...s, [k]: v }));

  const save = async () => {
    setSaving(true); setMsg('');
    try { await api.post('/settings', settings); setMsg('Settings saved successfully!'); setTimeout(() => setMsg(''), 3000); } catch { setMsg('Save failed'); }
    setSaving(false);
  };

  if (!settings) return <div className="loading"><div className="spinner" /></div>;

  const tabs = [['store','Store Info'],['hours','Hours'],['seo','SEO & Social'],['account','My Account']];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1a2744' }}>Settings</h1>
        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save All Changes'}</button>
      </div>
      {msg && <div className={`alert ${msg.includes('success') ? 'alert-success' : 'alert-error'}`} style={{ marginBottom: 16 }}>{msg}</div>}

      <div style={{ display: 'flex', gap: 4, background: '#f4f4f4', borderRadius: 10, padding: 4, marginBottom: 24, width: 'fit-content' }}>
        {tabs.map(([val, label]) => (
          <button key={val} onClick={() => setTab(val)} style={{ padding: '8px 18px', borderRadius: 8, border: 'none', fontWeight: 700, fontSize: 13, background: tab === val ? '#fff' : 'transparent', color: tab === val ? '#1a2744' : '#666', cursor: 'pointer', boxShadow: tab === val ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', transition: 'all 0.15s' }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: 28, boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
        {tab === 'store' && (
          <div>
            <h3 style={{ fontWeight: 700, color: '#1a2744', marginBottom: 20 }}>Store Information</h3>
            <div className="grid-2" style={{ gap: 16 }}>
              <div className="form-group"><label className="form-label">Store Name</label><input className="form-control" value={settings.store_name || ''} onChange={e => set('store_name', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Pawn Shop Phone</label><input className="form-control" value={settings.store_phone || ''} onChange={e => set('store_phone', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Tech Repair Phone (Screen Savers)</label><input className="form-control" value={settings.screen_savers_phone || ''} onChange={e => set('screen_savers_phone', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Email</label><input className="form-control" type="email" value={settings.store_email || ''} onChange={e => set('store_email', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Tech Repair Email (Screen Savers)</label><input className="form-control" type="email" value={settings.tech_repair_email || ''} onChange={e => set('tech_repair_email', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Street Address</label><input className="form-control" value={settings.store_address || ''} onChange={e => set('store_address', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">City</label><input className="form-control" value={settings.store_city || ''} onChange={e => set('store_city', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">State</label><input className="form-control" value={settings.store_state || ''} onChange={e => set('store_state', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">ZIP</label><input className="form-control" value={settings.store_zip || ''} onChange={e => set('store_zip', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Tax Rate (%)</label><input className="form-control" type="number" step="0.01" value={settings.tax_rate || ''} onChange={e => set('tax_rate', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Default Shipping Price ($)</label><input className="form-control" type="number" step="0.01" min="0" value={settings.default_shipping_price || ''} onChange={e => set('default_shipping_price', e.target.value)} /><div style={{ fontSize: 11, color: '#9a9a9a', marginTop: 4 }}>Per item, for items without their own shipping price</div></div>
              <div className="form-group"><label className="form-label">Heavy Item Shipping ($)</label><input className="form-control" type="number" step="0.01" min="0" value={settings.heavy_shipping_price || ''} onChange={e => set('heavy_shipping_price', e.target.value)} /><div style={{ fontSize: 11, color: '#9a9a9a', marginTop: 4 }}>The "Heavy" button in Inventory</div></div>
              <div className="form-group"><label className="form-label">Years in Business</label><input className="form-control" type="number" value={settings.years_in_business || ''} onChange={e => set('years_in_business', e.target.value)} /></div>
            </div>
            <div className="form-group"><label className="form-label">Home Page Section Title</label><input className="form-control" value={settings.home_section_title || ''} onChange={e => set('home_section_title', e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Home Page Section Text</label><textarea className="form-control" rows={4} value={settings.home_section_body || ''} onChange={e => set('home_section_body', e.target.value)} placeholder="Leave blank to show just the title and buttons" /></div>
            <div className="form-group"><label className="form-label">About Headline</label><input className="form-control" value={settings.about_headline || ''} onChange={e => set('about_headline', e.target.value)} /></div>
            <div className="form-group"><label className="form-label">About Body Text</label><textarea className="form-control" rows={4} value={settings.about_body || ''} onChange={e => set('about_body', e.target.value)} /></div>
          </div>
        )}

        {tab === 'hours' && (
          <div>
            <h3 style={{ fontWeight: 700, color: '#1a2744', marginBottom: 6 }}>Hours of Operation</h3>
            <p style={{ color: '#9a9a9a', fontSize: 13, marginBottom: 20 }}>Set "Closed" to mark a day as closed. Use format: 9:00 AM – 5:00 PM</p>
            {DAYS.map(day => (
              <div key={day} style={{ display: 'flex', gap: 16, alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f4f4f4' }}>
                <div style={{ width: 100, fontWeight: 700, fontSize: 14, color: '#1a2744' }}>{DAY_LABELS[day]}</div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flex: 1 }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
                    <input type="checkbox" checked={settings[`hours_${day}`] === 'Closed'} onChange={e => set(`hours_${day}`, e.target.checked ? 'Closed' : '9:00 AM – 5:00 PM')} />
                    Closed
                  </label>
                  {settings[`hours_${day}`] !== 'Closed' && (
                    <input className="form-control" style={{ maxWidth: 200 }} value={settings[`hours_${day}`] || ''} onChange={e => set(`hours_${day}`, e.target.value)} placeholder="9:00 AM – 5:00 PM" />
                  )}
                  {settings[`hours_${day}`] === 'Closed' && <span style={{ fontSize: 13, color: '#c62828', fontWeight: 600 }}>Closed</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {tab === 'seo' && (
          <div>
            <h3 style={{ fontWeight: 700, color: '#1a2744', marginBottom: 20 }}>SEO & Social Media</h3>
            <div className="form-group"><label className="form-label">Meta Title</label><input className="form-control" value={settings.meta_title || ''} onChange={e => set('meta_title', e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Meta Description</label><textarea className="form-control" rows={3} value={settings.meta_description || ''} onChange={e => set('meta_description', e.target.value)} maxLength={160} /><div style={{ fontSize: 11, color: '#9a9a9a', marginTop: 4 }}>{(settings.meta_description || '').length}/160 characters</div></div>
            <div className="form-group"><label className="form-label">Facebook URL</label><input className="form-control" value={settings.facebook_url || ''} onChange={e => set('facebook_url', e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Instagram URL</label><input className="form-control" value={settings.instagram_url || ''} onChange={e => set('instagram_url', e.target.value)} /></div>
          </div>
        )}

        {tab === 'account' && (
          <div>
            <h3 style={{ fontWeight: 700, color: '#1a2744', marginBottom: 20 }}>My Profile</h3>
            <EditProfile />
            <h3 style={{ fontWeight: 700, color: '#1a2744', margin: '32px 0 20px' }}>Change Password</h3>
            <ChangePassword />
          </div>
        )}
      </div>
    </div>
  );
}

function EditProfile() {
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  useEffect(() => { api.get('/admin/auth/me').then(r => setForm(r.data)).catch(() => {}); }, []);

  const save = async () => {
    if (!form.full_name) { setMsg('Name is required'); return; }
    setSaving(true); setMsg('');
    try {
      await api.put('/admin/auth/profile', { full_name: form.full_name, email: form.email });
      setMsg('Profile updated!');
      setTimeout(() => window.location.reload(), 800);
    } catch { setMsg('Save failed'); setSaving(false); }
  };

  if (!form) return null;

  return (
    <div style={{ maxWidth: 380 }}>
      {msg && <div className={`alert ${msg === 'Profile updated!' ? 'alert-success' : 'alert-error'}`} style={{ marginBottom: 16 }}>{msg}</div>}
      <div className="form-group"><label className="form-label">Full Name</label><input className="form-control" value={form.full_name || ''} onChange={e => set('full_name', e.target.value)} /></div>
      <div className="form-group"><label className="form-label">Email</label><input className="form-control" type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} /></div>
      <button className="btn btn-navy" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save Profile'}</button>
    </div>
  );
}

function ChangePassword() {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    if (form.new_password !== form.confirm) return setMsg('Passwords do not match');
    setSaving(true); setMsg('');
    try { await api.post('/admin/auth/change-password', form); setMsg('Password updated!'); setForm({ current_password: '', new_password: '', confirm: '' }); } catch (e) { setMsg(e.response?.data?.error || 'Failed'); }
    setSaving(false);
  };

  return (
    <div style={{ maxWidth: 380 }}>
      {msg && <div className={`alert ${msg === 'Password updated!' ? 'alert-success' : 'alert-error'}`} style={{ marginBottom: 16 }}>{msg}</div>}
      <div className="form-group"><label className="form-label">Current Password</label><input className="form-control" type="password" value={form.current_password} onChange={e => set('current_password', e.target.value)} /></div>
      <div className="form-group"><label className="form-label">New Password</label><input className="form-control" type="password" value={form.new_password} onChange={e => set('new_password', e.target.value)} /></div>
      <div className="form-group"><label className="form-label">Confirm New Password</label><input className="form-control" type="password" value={form.confirm} onChange={e => set('confirm', e.target.value)} /></div>
      <button className="btn btn-navy" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Update Password'}</button>
    </div>
  );
}
